import React, {Component} from 'react';
import './bars.css';
import '../../css/styles.css'

interface IBarsProps {
  maxDaysOfNormalProgress: number,
  daysInProgress: number,
  daysOfNormalProgress: number,
  daysToDeadline: number
}

interface IBarsState{
}
export default class Bars extends Component <IBarsProps, IBarsState> {

  constructor (props?:any) {
    super(props);

    this.state = {
    }
  }

  private getWidth(width: number): string {
    const p:number = Math.floor(width*100/this.props.maxDaysOfNormalProgress);
    return `${p.toString()}%`
  }

  /*TODO нарисовать надо два блока (или один):
      1) если daysToDeadline > 0, то рисую два блока:
        а) серый шириной daysInProgress
        б) зелёный шириной daysToDeadline
      2) если daysToDeadline = 0, то рисую один Серый блок длиной daysOfNormalProgress
  */
  private getBars():React.ReactElement {
    const gray_bar = {
      width: (this.props.daysToDeadline === 0)
             ? this.getWidth(this.props.daysOfNormalProgress)
             : this.getWidth(this.props.daysInProgress),
      backgroundColor:'lightgray',
      color:'gray'
    };
    const green_bar = {
      width: this.getWidth(this.props.daysToDeadline),
      backgroundColor:'green',
      color:'black'
    };
    return (<div className='w100pr block_flex_end font-weight-bold'>{(this.props.daysToDeadline === 0)
              ? <div style={gray_bar} className='shadow'>{this.props.daysOfNormalProgress}</div>
              : (<><div style={gray_bar} className='shadow'>{this.props.daysInProgress}</div>
                 <div style={green_bar} className='shadow'>{this.props.daysToDeadline}</div></>
                )}</div>)
  }

  render(): React.ReactNode {
    return (
      <>{this.getBars()}</>
    );
  }
}
